import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue, {
  BToast: {
    noCloseButton: true
  }
})
